import { render } from "./SliderWithInputBox.vue?vue&type=template&id=617c144f"
import script from "./SliderWithInputBox.vue?vue&type=script&lang=ts"
export * from "./SliderWithInputBox.vue?vue&type=script&lang=ts"
script.render = render

export default script